"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var repositoryAdmin;
        (function (repositoryAdmin) {
            var edit;
            (function (edit) {
                class InitArgs {
                    constructor() {
                        this.repositoryItemId = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                }
                edit.init = init;
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sDom: appn.dataTable.genSDom(0, 0, 0),
                        sAjaxSource: '../DataTableStoreItemInstalls',
                        searching: false,
                        fnServerData: function (data) {
                            data.push({ name: 'sCustom_0', value: '' }, { name: 'sCustom_1', value: _initArgs.repositoryItemId }, { name: 'sCustom_2', value: '' });
                        },
                        aaSorting: [[1, 'desc']],
                        aoColumns: [
                            { bSortable: true, sWidth: '60%' },
                            { bSortable: true, sWidth: '40%' }
                        ]
                    });
                }
            })(edit = repositoryAdmin.edit || (repositoryAdmin.edit = {}));
        })(repositoryAdmin = views.repositoryAdmin || (views.repositoryAdmin = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
